export const REPORTEXCISES_SEARCH = 'REPORTEXCISES_SEARCH';
export const REPORTEXCISES_PAGE = 'REPORTEXCISES_PAGE';
export const REPORTEXCISES_STARTDATE = 'REPORTEXCISES_STARTDATE';
export const REPORTEXCISES_ENDDATE = 'REPORTEXCISES_ENDDATE';
export const REPORTEXCISES_USER = 'REPORTEXCISES_USER';
export const REPORTEXCISES_COUNTRY = 'REPORTEXCISES_COUNTRY';
export const REPORTEXCISES_STATUS = 'REPORTEXCISES_STATUS';
export const REPORTEXCISES_THREEPSUPPLIER = 'REPORTEXCISES_THREEPSUPPLIER';